import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=2d0f4d52&scoped=true&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./mobileFooter.vue?vue&type=style&index=0&id=2d0f4d52&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d0f4d52",
  "137fc7b0"
  
)

component.options.__file = "mobileFooter.vue"
export default component.exports